import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  SimpleGrid,
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  useDisclosure,
  Flex,
  Stack,
  RadioGroup,
  Textarea,
  useColorMode,
  useColorModeValue,
  Skeleton,
  Divider,
  Text,
} from "@chakra-ui/react";
import Card from "components/Card/Card";
import axios from "axios";
import { toast } from "react-toastify";
import apiUrl from "variables/api";
import CustomCheckbox from "components/Checkbox/CustomCheckbox";
import CustomCheckboxButton from "components/Checkbox/CustomCheckboxButton";
import ReactSelect from "react-select";
import {
  onSiteVehiclesOptionsJRG1,
  onSiteVehiclesOptionsJRG2,
  onSiteVehiclesOptionsSP,
  onSiteVehiclesOptionsWSP,
  sluzby,
  grupy,
} from "variables/general";
import darkStyles from "variables/darkStyles";
import Creatable from "react-select/creatable";

import locations from "variables/locations";

export default function Edit() {
  const { colorMode } = useColorMode();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [incidentData, setIncidentData] = useState(null);
  const editRef = React.useRef();

  const validateId = (values) => {
    const errors = {};
    if (!values.dataId) {
      errors.dataId = "Musisz podać ID karty";
    }
    if (!values.incidentType) {
      errors.incidentType = "Musisz wybrać rodzaj karty";
    }
    return errors;
  };

  const [vehicles, setVehicles] = useState([]);
  useEffect(() => {
    axios
      .get(apiUrl + "/data/vehicles", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        const vehicles = response.data;
        const formattedData = vehicles.reduce((acc, item) => {
          const existingUnit = acc.find((unit) => unit.unit === item.unit);
          if (existingUnit) {
            existingUnit.vehicles.push(item.operationalNumber);
          } else {
            acc.push({ unit: item.unit, vehicles: [item.operationalNumber] });
          }
          return acc;
        }, []);
        setVehicles(formattedData);
        console.log(formattedData);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [peoples, setPeoples] = useState([]);
  useEffect(() => {
    axios
      .get(apiUrl + "/data/peoples", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
        response.data.push({ value: "WSP", label: "WSP" });
        setPeoples(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleFetchData = async (values) => {
    const { dataId, incidentType } = values;
    console.log(incidentType);
    const endpoint = `${apiUrl}/data/${
      incidentType == "SGRT" ||
      incidentType == "SGPR" ||
      incidentType == "SGRChem"
        ? "edit-group"
        : "edit"
    }/${dataId}?type=${incidentType}`;
    try {
      const response = await axios.get(endpoint, {
        headers: { "x-access-token": localStorage.getItem("token") },
      });
      if (response.data.error) {
        toast.error(response.data.error);
        return;
      }
      setIncidentData(response.data);
      console.log(response.data);
      onOpen();
    } catch (error) {
      console.error(error);
      toast.error("Błąd podczas pobierania danych");
    }
  };

  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const onDeleteDialogOpen = () => setDeleteDialogOpen(true);
  const onDeleteDialogClose = () => setDeleteDialogOpen(false);

  const handleDelete = async () => {
    const id = editRef.current.values.id;
    console.log(id);
    const { groupName } = incidentData;
    const endpoint = `${apiUrl}/data/${
      groupName == "sgrt" || groupName == "sgrt" || groupName == "sgrchem"
        ? "edit-group"
        : "edit"
    }/${id}`;
    try {
      const response = await axios.delete(endpoint, {
        headers: { "x-access-token": localStorage.getItem("token") },
      });
      if (response.data.success) {
        toast.success("Pomyślnie usunięto kartę");
        onClose();
      } else {
        toast.error("Błąd podczas usuwania karty");
      }
    } catch (error) {
      console.error(error);
      toast.error("Błąd podczas usuwania karty");
    }
    onDeleteDialogClose();
  };

  const handleEditSubmit = async (values) => {
    console.log(values);
    const { id } = values;
    const { groupName } = incidentData;
    console.log("cos", groupName);
    const endpoint = `${apiUrl}/data/${
      groupName == "sgrt" || groupName == "sgrt" || groupName == "sgrchem"
        ? "edit-group"
        : "edit"
    }/${id}`;
    console.log(endpoint);
    try {
      const response = await axios.put(endpoint, values, {
        headers: { "x-access-token": localStorage.getItem("token") },
      });
      if (response.data.success) {
        toast.success("Pomyślnie edytowano kartę");
      } else {
        toast.error("Błąd podczas edycji karty");
      }
    } catch (error) {
      console.error(error);
      toast.error("Błąd podczas połączenia z API");
    }
    onClose();
  };

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px">
        <Flex direction="column">
          <Formik
            initialValues={{ dataId: "", incidentType: "" }}
            validate={validateId}
            onSubmit={handleFetchData}
          >
            {({ isSubmitting, errors }) => (
              <Form>
                <SimpleGrid columns={{ sm: 1, md: 2 }} spacing="24px">
                  <Field name="dataId">
                    {({ field, form }) => (
                      <FormControl
                        isInvalid={errors.dataId && form.touched.dataId}
                      >
                        <FormLabel>ID Karty</FormLabel>
                        <Input
                          type="text"
                          {...field}
                          placeholder="Podaj ID karty"
                        />
                        <FormErrorMessage>{errors.dataId}</FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                  <Field name="incidentType">
                    {({ field, form }) => (
                      <FormControl
                        isInvalid={
                          errors.incidentType && form.touched.incidentType
                        }
                      >
                        <FormLabel>Rodzaj Karty</FormLabel>
                        <Stack direction="row">
                          <CustomCheckbox
                            key="SK"
                            label="SK"
                            isChecked={form.values.incidentType == "SK"}
                            onChange={() => {
                              form.setFieldValue(field.name, "SK");
                            }}
                          />
                          <CustomCheckbox
                            key="P"
                            label="Pożar"
                            isChecked={form.values.incidentType == "P"}
                            onChange={() => {
                              form.setFieldValue(field.name, "P");
                            }}
                          />
                          <CustomCheckbox
                            key="MZ"
                            label="Miejscowe zagrożenie"
                            isChecked={form.values.incidentType == "MZ"}
                            onChange={() => {
                              form.setFieldValue(field.name, "MZ");
                            }}
                          />
                          <CustomCheckbox
                            key="AF"
                            label="Alarm fałszywy"
                            isChecked={form.values.incidentType == "AF"}
                            onChange={() => {
                              form.setFieldValue(field.name, "AF");
                            }}
                          />
                          <CustomCheckbox
                            key="SGPR"
                            label="SGPR"
                            isChecked={form.values.incidentType == "SGPR"}
                            onChange={() => {
                              form.setFieldValue(field.name, "SGPR");
                            }}
                          />
                          <CustomCheckbox
                            key="SGRT"
                            label="SGRT"
                            isChecked={form.values.incidentType == "SGRT"}
                            onChange={() => {
                              form.setFieldValue(field.name, "SGRT");
                            }}
                          />
                          <CustomCheckbox
                            key="SGRChem"
                            label="SGRChem"
                            isChecked={form.values.incidentType == "SGRChem"}
                            onChange={() => {
                              form.setFieldValue(field.name, "SGRChem");
                            }}
                          />
                        </Stack>
                        <FormErrorMessage>
                          {errors.incidentType}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                </SimpleGrid>
                <Button
                  mt={4}
                  colorScheme="red"
                  isLoading={isSubmitting}
                  type="submit"
                >
                  Przejdź do edycji
                </Button>

                <AlertDialog isOpen={isOpen} onClose={onClose} size="7xl">
                  <AlertDialogOverlay>
                    <AlertDialogContent>
                      <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        Edytuj kartę
                      </AlertDialogHeader>
                      <AlertDialogBody>
                        {incidentData && (
                          <Formik
                            initialValues={{
                              id: incidentData.id,
                              type: incidentData.type,
                              dateTime: new Date(incidentData.date)
                                .toISOString()
                                .slice(0, 16),
                              reporter: incidentData.reporting ?? null,
                              location: {
                                value: incidentData.location,
                                label: incidentData.location,
                              },
                              commander: incidentData.commander
                                ? peoples.find(
                                    (element) =>
                                      element.value === incidentData.commander
                                  )
                                : null,
                              peoplesOnSite: incidentData.rescuers
                                ? JSON.parse(incidentData.rescuers).map((e) =>
                                    peoples.find(
                                      (element) => element.value === e
                                    )
                                  )
                                : [],
                              onSiteServices: incidentData.services
                                ? JSON.parse(incidentData.services)
                                : null,
                              onSiteVehicles: JSON.parse(incidentData.carts),
                              incidentDescription: incidentData.description,
                            }}
                            onSubmit={handleEditSubmit}
                            innerRef={editRef}
                          >
                            {({ isSubmitting }) => (
                              <Form>
                                <SimpleGrid
                                  columns={{ sm: 1, md: 2, xl: 4 }}
                                  spacing="24px"
                                  mb="20px"
                                >
                                  <Field name="dateTime">
                                    {({ field, form }) => (
                                      <FormControl
                                        id="dateTime"
                                        isRequired
                                        isInvalid={
                                          form.errors.dateTime &&
                                          form.touched.dateTime
                                        }
                                      >
                                        <FormLabel>Data i godzina</FormLabel>
                                        <Input
                                          type="datetime-local"
                                          {...field}
                                          placeholder="Data i godzina"
                                        />
                                        <FormErrorMessage>
                                          {form.errors.dateTime}
                                        </FormErrorMessage>
                                      </FormControl>
                                    )}
                                  </Field>
                                  {incidentData.reporting && (
                                    <Field name="reporter">
                                      {({ field, form }) => (
                                        <FormControl
                                          id="reporter"
                                          isRequired
                                          isInvalid={
                                            form.errors.reporter &&
                                            form.touched.reporter
                                          }
                                        >
                                          <FormLabel>Zgłaszający</FormLabel>
                                          <Input
                                            {...field}
                                            placeholder="Zgłaszający"
                                          />
                                          <FormErrorMessage>
                                            {form.errors.reporter}
                                          </FormErrorMessage>
                                        </FormControl>
                                      )}
                                    </Field>
                                  )}
                                  <Field name="location">
                                    {({ field, form }) => (
                                      <FormControl
                                        id="location"
                                        isRequired
                                        isInvalid={
                                          form.errors.location &&
                                          form.touched.location
                                        }
                                      >
                                        <FormLabel>Lokalizacja</FormLabel>
                                        <Creatable
                                          {...field}
                                          options={locations}
                                          placeholder="Wybierz..."
                                          styles={darkStyles()}
                                          value={form.values[field.name]}
                                          onChange={(selectedOptions) => {
                                            form.setFieldValue(
                                              field.name,
                                              selectedOptions
                                            );
                                          }}
                                          formatCreateLabel={(inputValue) =>
                                            `Niestandardowa: ${inputValue}`
                                          }
                                        />
                                        <FormErrorMessage>
                                          {form.errors.location}
                                        </FormErrorMessage>
                                      </FormControl>
                                    )}
                                  </Field>
                                  {!incidentData.groupName && (
                                    <Field name="commander">
                                      {({ field, form }) => (
                                        <FormControl
                                          id="commander"
                                          isRequired
                                          isInvalid={
                                            form.errors.commander &&
                                            form.touched.commander
                                          }
                                        >
                                          <FormLabel>Dowódca</FormLabel>
                                          <ReactSelect
                                            {...field}
                                            options={peoples}
                                            isLoading={peoples.length === 0}
                                            noOptionsMessage={() =>
                                              "Brak dostępnych opcji"
                                            }
                                            placeholder="Wybierz..."
                                            styles={darkStyles()}
                                            value={form.values?.commander}
                                            onChange={(selectedOptions) => {
                                              form.setFieldValue(
                                                field.name,
                                                selectedOptions
                                              );
                                            }}
                                          />
                                          <FormErrorMessage>
                                            {form.errors.commander}
                                          </FormErrorMessage>
                                        </FormControl>
                                      )}
                                    </Field>
                                  )}
                                </SimpleGrid>
                                <SimpleGrid
                                  columns={{ sm: 1, md: 2, xl: 3 }}
                                  spacing="24px"
                                  mb="20px"
                                >
                                  {incidentData.type != "1" && (
                                    <Field name="peoplesOnSite">
                                      {({ field, form }) => (
                                        <FormControl
                                          id="peoplesOnSite"
                                          isRequired
                                          isInvalid={
                                            form.errors.peoplesOnSite &&
                                            form.touched.peoplesOnSite
                                          }
                                        >
                                          <FormLabel>
                                            Osoby na zdarzeniu
                                          </FormLabel>
                                          <ReactSelect
                                            {...field}
                                            noOptionsMessage={() =>
                                              "Brak dostępnych opcji"
                                            }
                                            options={peoples.filter(
                                              (element) =>
                                                element.value !==
                                                form.values.commander?.value
                                            )}
                                            placeholder="Wybierz..."
                                            styles={darkStyles()}
                                            value={form.values.peoplesOnSite}
                                            isMulti
                                            onChange={(selectedOptions) => {
                                              form.setFieldValue(
                                                field.name,
                                                selectedOptions
                                              );
                                            }}
                                          />
                                          <FormErrorMessage>
                                            {form.errors.peoplesOnSite}
                                          </FormErrorMessage>
                                        </FormControl>
                                      )}
                                    </Field>
                                  )}
                                  {!incidentData.groupName && (
                                    <Field name="onSiteServices">
                                      {({ field, form }) => (
                                        <FormControl
                                          isInvalid={
                                            form.errors.onSiteServices &&
                                            form.touched.onSiteServices
                                          }
                                        >
                                          <FormLabel>
                                            Służby na miejscu
                                          </FormLabel>
                                          <Stack direction="row">
                                            {sluzby.map((option) => (
                                              <CustomCheckbox
                                                key={option.value}
                                                label={option.label}
                                                colorScheme={option.color}
                                                isChecked={form.values.onSiteServices?.includes(
                                                  option.value
                                                )}
                                                onChange={() => {
                                                  const nextValue = field.value.includes(
                                                    option.value
                                                  )
                                                    ? field.value.filter(
                                                        (value) =>
                                                          value !== option.value
                                                      )
                                                    : [
                                                        ...field.value,
                                                        option.value,
                                                      ];
                                                  form.setFieldValue(
                                                    field.name,
                                                    nextValue
                                                  );
                                                }}
                                              />
                                            ))}
                                          </Stack>
                                          <FormErrorMessage>
                                            {form.errors.onSiteServices}
                                          </FormErrorMessage>
                                        </FormControl>
                                      )}
                                    </Field>
                                  )}
                                </SimpleGrid>
                                <Field name="onSiteVehicles">
                                  {({ field, form }) => (
                                    <FormControl
                                      id="onSiteVehicles"
                                      isInvalid={
                                        form.errors.onSiteVehicles &&
                                        form.touched.onSiteVehicles
                                      }
                                    >
                                      <FormLabel textAlign={"center"}>
                                        <Text
                                          fontWeight={"bold"}
                                          fontSize={"md"}
                                        >
                                          Zastępy na miejscu
                                        </Text>
                                      </FormLabel>
                                      <Flex
                                        direction={{
                                          base: "column",
                                          xl: "row",
                                        }}
                                        wrap="wrap"
                                        justifyContent={{
                                          base: "center",
                                          xl: "space-between",
                                        }}
                                        alignItems="stretch"
                                      >
                                        {vehicles.length === 0 ? (
                                          <Skeleton
                                            height="200px"
                                            width="100%"
                                          />
                                        ) : (
                                          vehicles.map((unit, index) => (
                                            <React.Fragment key={unit.unit}>
                                              <Flex
                                                direction={"column"}
                                                flex="1"
                                                mx={2}
                                                mb={4}
                                              >
                                                <FormLabel
                                                  fontWeight="bold"
                                                  textAlign={"center"}
                                                >
                                                  {unit.unit}
                                                </FormLabel>
                                                <SimpleGrid
                                                  columns={{
                                                    sm: 2,
                                                    md: 3,
                                                    xl: 3,
                                                  }}
                                                  spacing="24px"
                                                  mb="20px"
                                                >
                                                  {unit.vehicles.map(
                                                    (vehicle) => (
                                                      <CustomCheckboxButton
                                                        key={vehicle}
                                                        label={vehicle}
                                                        isChecked={form.values.onSiteVehicles.includes(
                                                          vehicle
                                                        )}
                                                        onChange={() => {
                                                          const nextValue = field.value.includes(
                                                            vehicle
                                                          )
                                                            ? field.value.filter(
                                                                (value) =>
                                                                  value !==
                                                                  vehicle
                                                              )
                                                            : [
                                                                ...field.value,
                                                                vehicle,
                                                              ];
                                                          form.setFieldValue(
                                                            field.name,
                                                            nextValue
                                                          );
                                                        }}
                                                      />
                                                    )
                                                  )}
                                                </SimpleGrid>
                                              </Flex>
                                              {index < vehicles.length - 1 && (
                                                <Divider
                                                  orientation="vertical"
                                                  height="auto"
                                                  mx={2}
                                                />
                                              )}
                                            </React.Fragment>
                                          ))
                                        )}
                                      </Flex>
                                      <FormErrorMessage>
                        {form.errors[field.name]}
                      </FormErrorMessage>
                                    </FormControl>
                                  )}
                                </Field>

                                <Field name="incidentDescription">
                                  {({ field }) => (
                                    <FormControl id="incidentDescription">
                                      <FormLabel>Opis zdarzenia</FormLabel>
                                      <Textarea
                                        {...field}
                                        placeholder="Opis zdarzenia"
                                        maxH={"500px"}
                                      />
                                    </FormControl>
                                  )}
                                </Field>

                                <Button
                                  mt={4}
                                  colorScheme="red"
                                  isLoading={isSubmitting}
                                  type="submit"
                                >
                                  Zapisz zmiany
                                </Button>
                                <Button
                                  mt={4}
                                  ml={4}
                                  colorScheme="red"
                                  isLoading={isSubmitting}
                                  onClick={onDeleteDialogOpen}
                                >
                                  Usuń kartę
                                </Button>
                                <Button mt={4} ml={4} onClick={onClose}>
                                  Anuluj
                                </Button>
                              </Form>
                            )}
                          </Formik>
                        )}
                      </AlertDialogBody>
                      <AlertDialogFooter></AlertDialogFooter>
                    </AlertDialogContent>
                  </AlertDialogOverlay>
                </AlertDialog>
              </Form>
            )}
          </Formik>
        </Flex>
      </Card>
      <AlertDialog
        isOpen={isDeleteDialogOpen}
        leastDestructiveRef={undefined}
        onClose={onDeleteDialogClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Potwierdź usunięcie
            </AlertDialogHeader>
            <AlertDialogBody>
              Czy na pewno chcesz usunąć tę kartę? Tej operacji nie można
              cofnąć.
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button onClick={onDeleteDialogClose}>Anuluj</Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Usuń
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Flex>
  );
}
